import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Resolve, RouterStateSnapshot, Routes} from '@angular/router';

import {Principal} from '../../shared';
import {PaginationUtil} from 'ng-jhipster';

import {UserEchangeMgmtComponent} from './user-echange.component';
import {UserEchangeMgmtDetailComponent} from './user-echange-detail.component';
import {UserEchangeDialogComponent} from './user-echange-dialog.component';
import {UserEchangeDeleteDialogComponent} from './user-echange-delete-dialog.component';


@Injectable()
export class UserEchangeResolve implements CanActivate {

  constructor(private principal: Principal) { }

  canActivate() {
    return this.principal.identity().then(account => {
        return this.principal.hasAnyAuthority(['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST']);
    } );
  }
}

@Injectable()
export class UserEchangeResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const userEchangeRoute: Routes = [
  {
    path: 'user-echange',
    component: UserEchangeMgmtComponent,
    data: {
      pageTitle: 'userEchange.home.title'
    }
  },
  {
    path: 'user-echange/:login',
    component: UserEchangeMgmtDetailComponent,
    data: {
      pageTitle: 'userEchange.home.title'
    }
  }
];

export const userEchangeDialogRoute: Routes = [
  {
      path: 'user-echange-new/:typeEtudiant',
    component: UserEchangeDialogComponent,
    outlet: 'popup'
  },
  {
    path: 'user-echange/:id/edit',
    component: UserEchangeDialogComponent,
    outlet: 'popup'
  },
  {
    path: 'user-echange/:id/delete',
    component: UserEchangeDeleteDialogComponent,
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-echange/user-echange.route.ts